import React, { useEffect, useMemo, useState } from 'react';
import { connect } from "react-redux";
import { Col, Row } from "react-bootstrap";
// import { Row, Col } from "antd";
import useWindowSize from "../../utils/useWindowSize";
import Logout from "../../containers/Pages/Login/Logout";
import ChangePassword from "../../containers/Pages/Login/ChangePassword";
import { Button, Checkbox, Radio, Badge, message } from "antd";
import { datasocurceLanPayout } from '../PayoutManagement/helper/payoutdatasample';
import LanPayoutDashboardList from './LanPayoutDashboardList';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useSession from '../CustomLogout/useSession';
import { payoutLandataAction, payoutPartnerLansearch } from '../../redux/PayoutLanData/Action';
import { partnerpayoutLanReportSummary } from '../../redux/PartnerPayoutLanData/action';
import { getRaisePayoutQueryInternalAction } from '../../redux/PayoutQueryInternal/Action';
import { LeftCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { debounce } from 'lodash';



const LanPayoutDashboard = (props) => {

  const { width } = useWindowSize();
  const [landatasource, setLanDatasource] = useState([]);
  const [allCount, setAllCount] = useState(0);
  const [regularCount, setRegularCount] = useState(0);
  const [searchTextTable, setSearchTextTable] = useState("");
  const [holdCount, setHoldCount] = useState(0);
  const [recoveryCount, setRecoveryCount] = useState(0);
  const [retroCount, setRetroCount] = useState(0);
  const [queryCount, setQueryCount] = useState(0);
  const [partnerAction, setPartnerAction] = useState(false);
  const [radiostate, setRadioState] = useState("ALL");
  const { monthlyReportId } = useParams();
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({ Check: [] });
  const handleSessionExpired = useSession();
  const location = useLocation();
  const partnerId = location.state?.partnerId || null; // Get partnerId from state or use null if not available
  const fileName = location.state?.fileName || null;
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '50', '100', '200'],
  });
  const [partnerList, setPartnerList] = useState([]);
  const [summaryData, setSummaryData] = useState({});
  const [remarkComment, setRemarkComment] = useState('');
  const [addQueryOpen, setAddQueryOpen] = useState(false);
  const [downloadAction, setDownloadAction] = useState(false);
  const [makerAction,setMakerAction] = useState(false);
  const [recovery, setRecovery] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {

    handleRadioChange(radiostate, datasocurceLanPayout)
    
  }, []);

  const options = [
    {
      label: (
        <div
          style={{
            position: "relative",
            fontSize: "0.8rem",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            lineHeight: "60px"
          }}
        >
          ALL
          {/* <Badge
            shape="circle"
            showZero
            count={allCount}
            style={{ position: "absolute", top: -38, right: -27, zIndex: 1 }}
          /> */}
        </div>
      ), value: "ALL"
    },
    {
      label: (
        <div
          style={{
            position: "relative",
            fontSize: "0.8rem",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          Regular
          {/* <Badge
            shape="circle"
            showZero
            count={regularCount}
            style={{ position: "absolute", top: -38, right: -27, zIndex: 1 }}
          /> */}
        </div>
      ), value: "REGULAR"
    },
    {
      label: (
        <div
          style={{
            position: "relative",
            fontSize: "0.8rem",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          On Hold
          {/* <Badge
            shape="circle"
            showZero
            count={holdCount}
            style={{ position: "absolute", top: -38, right: -27, zIndex: 1 }}
          /> */}
        </div>
      ), value: "ONHOLD"
    },
    {
      label: (
        <div
          style={{
            position: "relative",
            fontSize: "0.8rem",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          Recovery
          {/* <Badge
            shape="circle"
            showZero
            count={recoveryCount}
            style={{ position: "absolute", top: -38, right: -27, zIndex: 1 }}
          /> */}
        </div>
      ), value: "RECOVERY"
    },
    {
      label: (
        <div
          style={{
            position: "relative",
            fontSize: "0.8rem",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          Retrospective Adjustment
          {/* <Badge
            shape="circle"
            showZero
            count={retroCount}
            style={{ position: "absolute", top: -38, right: -27, zIndex: 1 }}
          /> */}
        </div>
      ), value: "RETROSPECTIVE"
    },
    {
      label: (
        <div
          style={{
            position: "relative",
            fontSize: "0.8rem",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          Query
          {/* <Badge
            shape="circle"
            showZero
            count={queryCount}
            style={{ position: "absolute", top: -38, right: -27, zIndex: 1 }}
          /> */}
        </div>
      ), value: "QUERY"
    },
  ];

  // useEffect(()=>{
  //  fetchPaginatedData(radiostate)
  // }, [radiostate]);

  useEffect(() => {
   
  }, [selectedCheckboxes]);

  const handleCheckboxChange = (e, column, rowId) => {
    const isChecked = e.target.checked;
    setSelectedCheckboxes((prevState) => {
      const newState = { ...prevState };
      if (isChecked) {
        newState[column] = [...newState[column], rowId];
      } else {

        newState[column] = newState[column].filter((item) => item !== rowId);
      }
      return newState;
    });
  };

  useEffect(() => {
    fetchMonthlySummary();
  }, [monthlyReportId]);

  //fetch Monthly summary report

  const fetchMonthlySummary = async () => {
    try {

      const summaryResponse = await props.partnerpayoutLanReportSummary({
        accessToken: props.accessToken,
        reportId: monthlyReportId,
        partnerId: partnerId,
      });
      const data = await summaryResponse;
      const errorCode = data?.response?.data?.error?.errorCode || data.errorCode;
      const errorMessage = data?.response?.data?.error?.errorMessage || data.errorMessage;
      if (errorCode === "403" && (data?.response?.data?.error?.logoutStatus || data?.data?.error?.logoutStatus)) {
        // Handle logout status
        handleSessionExpired();
        return;
      }
      setSummaryData(data || []);
      
      return data;
    } catch (error) {
      setSummaryData([]);
      return (error)
    }
  }

  const handlePageChange = async (page, pageSize, lanStag) => {

    // Call the API with the new page and pageSize
    // const payoutPartnerResponse = await props.payoutLanDataSuccess({
    //   accessToken: props.accessToken,
    //   reportId: ReportId,
    //   partnerId: partnerId,
    //   tab: lanStag,
    //   page: page,
    //   records: pageSize,

    // });

    const payoutPartnerResponse = await props.payoutLanDataSuccess({
      accessToken: props.accessToken,
      reportId: monthlyReportId,
      partnerId: partnerId,
      tab: lanStag,
      page: page,
      records: pageSize,
    });
    const res = payoutPartnerResponse;
    setLanDatasource(res.payoutLanReport || []);
    
    setPagination((prev) => ({
      ...prev,
      current: page,
      pageSize,
      total: res?.totalElements,
    }));
    // setPagination((prev) => ({
    //   ...prev,
    //   total: res?.totalElements,
    // }));
  };


  const debouncedSearch = useMemo(() => 
  debounce(async (value) => {
    const searchValue = String(value || "").trim().toLowerCase();
    
    if (!searchValue) {
      setPagination(prev => ({
        ...prev,
        current: 1,
        pageSize: 10,
      }));
      await fetchPaginatedData(radiostate);
      return;
    }

    try {
      
      let response = await props.payoutPartnerLansearch({
        accessToken: props.accessToken,
        reportId: monthlyReportId,
        lanTab: radiostate,
        lanNo: searchValue,
        partnerId: partnerId
      });
      
      
      
      if (!response || !response?.payoutLanReport || response?.payoutLanReport.length === 0) {
        
        response = await props.payoutPartnerLansearch({
          accessToken: props.accessToken,
          reportId: monthlyReportId,
          lanTab: radiostate,
          applicantName: searchValue,
          partnerId: partnerId
        });
        
      }
      
    
      const searchData = response || {};
      const lanReportData = searchData.payoutLanReport || [];
      
     
      
     
      setLanDatasource(lanReportData);
      
      
      const totalResults = lanReportData.length;
      setPagination(prev => ({
        ...prev,
        current: 1, 
        total: totalResults,
        pageSize: totalResults > 0 ? Math.max(totalResults, 10) : 10, 
      }));
      
      
      if (totalResults === 0) {
        message.info(`No results found for "${searchValue}"`);
      }
      
    } catch (error) {
      console.error("Search error:", error);
      message.error("Search failed. Please try again.");
      
      await fetchPaginatedData(radiostate);
      
    }
  }, 300), 
  [props.accessToken, monthlyReportId, radiostate, partnerId, props.payoutPartnerLansearch] 
);
    
    
    useEffect(() => {
      return () => {
        debouncedSearch.cancel();
      };
    }, [debouncedSearch]);
    
    
        const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTextTable(value);
        debouncedSearch(value);
        
        
      };


  const fetchPaginatedData = async (lanStag) => {
    let current = pagination.current || 1;
    let pageSize = pagination.pageSize || 10;
    setSearchTextTable("");
    const response = await props.payoutLanDataSuccess({
      accessToken: props.accessToken,
      reportId: monthlyReportId,
      partnerId: partnerId,
      tab: lanStag,
      page: current - 1,
      records: pageSize,
    });

    const errorCode = response?.data?.error?.errorCode || response.errorCode;

    if (errorCode && errorCode === 403 && (response?.data?.error?.errorCode || response.errorCode)) {
      handleSessionExpired(); //Logout the user if session expired
      return;
    }

    
    const data = response.payoutLanReport || [];
   

    setPagination((prev) => ({
      ...prev,
      current,
      pageSize,
      total: response?.totalElements,
    }));

    if (lanStag == "REGULAR") {

    } else {
      setPartnerList([]);
    }
    setLanDatasource(data);
    setQueryCount(data.length);
    setDownloadAction( lanStag === "REGULAR" || lanStag === "ONHOLD");
    setRecovery(lanStag === "RECOVERY")
    setMakerAction(lanStag === "ALL" );
    // setCheckerAction(lanStag === "REGULAR");
    setSelectedCheckboxes({ Check: [] });
    setRadioState(lanStag);
  };

  const handleQueryRemark = async () => {
  
    // const getpartnerIds = Object.keys(selectedCheckboxes.Check).length > 0 ? selectedCheckboxes.Check.map(item => item.partnerId) : [selectedPartnerId];

    const queryData = {
      "partnerid": [partnerId],
      "reportid": monthlyReportId,
      "userId": props.userDetail?.userId,
      "payoutid": [],
      "stage": 6, // Assuming stage 6 is for PartnerQuery
      "remarks": {
        "partnerId": partnerId,
        "reportId": monthlyReportId,
        "userId": props.userDetail?.userId,
        "remarksComment": remarkComment,
        "stage": 6, // Assuming stage 6 is for PartnerQuery
        "remarkType": "PartnerQuery"
      }
    };

    
    try {

      const resQuery = await props.RaiseQuery({
        accessToken: props.accessToken,
        query: queryData
      });

      
      setRemarkComment('');
      setAddQueryOpen(false);
      return resQuery;

    } catch (error) {
      console.error("Error in handleQueryRemark:", error);
      return "Error while RaiseQuery" + error.message || "Error while RaiseQuery";
    }

  }


  const handleRadioChange = async (value, data = datasocurceLanPayout) => {
   

    switch (value) {
      case "ALL":
        
        fetchPaginatedData("ALL");
        break;

      case "REGULAR":
        
        fetchPaginatedData("REGULAR");
        break;

      case "RECOVERY":
        
        fetchPaginatedData("RECOVERY");
        break;

      case "ONHOLD":
        
        fetchPaginatedData("ONHOLD");
        break;

      case "RETROSPECTIVE":
        
        fetchPaginatedData("RETROSPECTIVE");
        break;

      case "QUERY":
        
        fetchPaginatedData("QUERY");
        break;

      default:
        
        break;
    }
  }

  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  return (
    <div className="lanDashboard-container" style={{ maxWidth: "100%" }}>
      {width < 786 && (
        <Row>
          <Col lg={12} xs={12} md={12} sm={12}></Col>
        </Row>
      )}
      {width > 786 && (
        <Row>
          <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
            <Col md={8} className="search-bar">
              <Button
                type="default"
                style={{
                  margin: "0",
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '2px', // space between icon and text
                  padding: '0 8px',
                  color:'#00b1b1',
                }}
                onClick={() => navigate(-1)}
              >
                <LeftCircleOutlined />
                <span>Back</span>
              </Button>
             { (fileName !== null)&& (<div >
                <p style={{marginBottom:"0", marginTop:"2%", marginLeft:"2%"}} ><b>Report Name:</b> {fileName}</p>
              </div>)}
            </Col>

            <Col md={4}>
              <div className="login-profie">
                <div className="img-sec">
                  <h2>
                    {adminFirstName(
                      props.userDetail?.firstName ??
                      props.userDetail?.userName?.split(" ")[0]?.trim()
                    )}
                  </h2>
                  <h2>
                    {adminLastName(
                      props.userDetail?.lastName ??
                      props.userDetail?.userName?.split(" ")[1]?.trim()
                    )}
                  </h2>
                </div>

                <div className="content-login">
                  <h4>{props.userDetail?.userName}</h4>
                  <h5>{props.userDetail?.roleName}</h5>
                  <div className="content-login-data">
                    <ChangePassword />
                    <div className="admin-small-space"> </div>
                    <Logout />
                    {/* <h6>Change Password | Logout</h6> */}
                  </div>
                </div>
              </div>
            </Col>
          </Col>
        </Row>
      )}
      <Row>
        <div className='displayContainer' style={{ marginTop: "10%", display: "flex", width: "100%", minWidth: "100%", overflow: "auto" }}>
          <Col md={8} style={{ maxWidth: "100%", width: "auto", minWidth: "60%" }}>
            <div className="buckets-container" style={{ overflowX: "auto", whiteSpace: "nowrap", width: "auto" }}>
              <Radio.Group
                block
                options={options}
                defaultValue="ALL"
                onChange={(e) => {
                  handleRadioChange(e.target.value);
                }}
                optionType="button"
                buttonStyle="solid"
                buttonCheckedBg="#1b8593"
              />
            </div>
          </Col>
          <Col md={4} style={{ maxWidth: "100%", flex: " 0 0 auto", width: "auto", minWidth: "33%" }}>
            <div className='statusTableContainer' style={{ minWidth: "20%", height: "auto", background: "#fff", boxShadow: "0px 0px 5px #ccc", borderRadius: "5px", display: "flex", justifyContent: "center", alignItems: "center", padding: "10px" }}>

              <table className="statusTable" style={{ width: "100%", textAlign: "left", borderCollapse: "collapse", width: "auto" }}>
                <tbody>
                  <tr>
                    <th style={{ padding: "8px", border: "1px solid #ccc", backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Payable Amount</th>
                    <td style={{ padding: "8px", border: "1px solid #ccc" }}>{summaryData.totalPayoutAmount}</td>
                  </tr>
                  <tr>
                    <th style={{ padding: "8px", border: "1px solid #ccc", backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Disbur. Count</th>
                    <td style={{ padding: "8px", border: "1px solid #ccc" }}>{summaryData.disbursementCount}</td>
                  </tr>

                </tbody>
              </table>
            </div>
          </Col>
        </div>
      </Row>
      <Row>
        <Col>
        <Input
            //  disabled={!searchlandatasource.length}
              className="search-input"
              allowClear
              placeholder="Search..."
              suffix={<SearchOutlined />}
              value={searchTextTable}
              onChange={handleSearch}
              style={{ width: 200, float: "right" }}
            />
        </Col>
      </Row>


      <Row style={{ display: "flex" }}>
        <LanPayoutDashboardList
          landataSource={landatasource}
          setLanDatasource={setLanDatasource}
          partnerAction={partnerAction}
          setPartnerAction={setPartnerAction}
          handleRadioChange={handleRadioChange}
          radiostate={radiostate}
          setRadioState={setRadioState}
          handleCheckboxChange={handleCheckboxChange}
          selectedCheckboxes={selectedCheckboxes}
          setSelectedCheckboxes={setSelectedCheckboxes}
          setRemarkComment={setRemarkComment}
          remarkComment={remarkComment}
          handleQueryRemark={handleQueryRemark}
          pagination={pagination}
          onPageChange={handlePageChange}
          addQueryOpen={addQueryOpen}
          setAddQueryOpen={setAddQueryOpen}
          downloadAction={downloadAction}
          setDownloadAction={setDownloadAction}
          recovery = {recovery}
          setRecovery = {setRecovery}
          makerAction={makerAction}
          setMakerAction={setMakerAction}
        />
      </Row>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    payoutLanDataSuccess: (data) => dispatch(payoutLandataAction(data)),
    partnerpayoutLanReportSummary: (data) => dispatch(partnerpayoutLanReportSummary(data)),
    RaiseQuery: (data) => dispatch(getRaisePayoutQueryInternalAction(data)),
    payoutPartnerLansearch: (data) => dispatch(payoutPartnerLansearch(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    userDetail: state.auth?.userData,
    accessToken: state && state.auth && state.auth.idToken,

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LanPayoutDashboard)